import { Link } from "react-router-dom";
import type { Article } from "@/mocks/content";
import ArticleCard from "@/components/base/ArticleCard";

type Props = {
  articles: Article[];
};

export default function LatestArticles({ articles }: Props) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-newspaper-line"></i>
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">最新内容</h3>
        </div>
        <Link
          to="/category/film-info"
          className="flex cursor-pointer items-center gap-1 text-sm text-foreground-600 transition-colors hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 md:gap-5 md:p-5">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </div>
  );
}